import htmlParser from 'html-react-parser';
import { domToReact } from 'html-react-parser';
import style from 'style-to-object';
import DOMPurify from 'dompurify';
import _ from 'lodash';

export const parseHTML = (html) => {
  const cleanHTML = DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
  return htmlParser(cleanHTML, {
    trim: true,
    replace: (domNode) => {
      if (domNode.attribs && domNode.attribs.style) {
        try {
          style(domNode.attribs.style);
        } catch (error) {
          // delete the style attribute that's causing parsing errors
          delete domNode.attribs.style;
          return domToReact(domNode);
        }
      }
    },
  });
};

export const isHTML = (str) => {
  return /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/.test(str);
};

export const parsePath = (path) => {
  const index = path.lastIndexOf('/');
  return index > 0
    ? {
        prefix: path.slice(0, index),
        suffix: path.slice(index),
      }
    : {
        prefix: path,
        suffix: '',
      };
};

export const resolveErrorMessage = (
  error,
  { defaultMessage = 'An error occured! please try again later.' } = {}
) => {
  return (
    error.response?.data?.message ||
    error.response?.data?.result?.map(({ message }) => message).join('\n') ||
    defaultMessage
  );
};

export const capitalize = (str, lowercaseRest = false) => {
  return _.isString(str)
    ? str
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + (lowercaseRest ? s.slice(1).toLowerCase() : s.slice(1)))
        .join(' ')
    : str;
};

export const truncate = (str, maxLength = 1000) => {
  return str?.slice(0, maxLength);
};

export const toArray = (value) => {
  return _.isArray(value) ? value : [value];
};
